import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TokenService } from './token.service';
import { embedClient } from '../model/leader-board.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) { }

  signUp(user: {
    name: string;
    email: string;
    password: string;
  }): Observable<any> {
    return this._httpClient.post(environment.apiUrl + 'auth/register', user);
  }

  login(user: {
    email: string;
    password: string;
  }): Observable<any> {
    return this._httpClient.post(environment.apiUrl + 'auth/login', user);
  }

  isSignedIn(): boolean {
    const token = this._tokenService.getToken;
    return token != null;
  }

  socialMediaLogin(socialMedia: string, action: string, source: string) {
    const url = environment.apiUrl + `auth/${socialMedia}?action=${action}&source=${source}`;
    window.location.replace(url);
  }

  forgotPassword(obj: any): Observable<any> {
    return this._httpClient.post(environment.apiUrl + 'auth/forgot-password', obj);
  }

  resetPassword(obj: any): Observable<any> {
    return this._httpClient.post(environment.apiUrl + 'auth/reset-password', obj);
  }

  confirmEmail(code: string, token: string) {
    return this._httpClient.post(environment.apiUrl + `auth/verify-email?token=${code}`, {},
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'skip-interceptor': 'true'
        }
      }
    );
  }

  setCookie() {
  return this._httpClient.post(environment.apiUrl + `auth/set-cookie`, { withCredentials: true });
}

  verifyIntegration(token: string) {
    return this._httpClient.get<embedClient>(environment.apiUrl + `auth/integration/verify/${token}`);
  }

  getPhoneCodes(): any{
    return this._httpClient.get("assets/json/phoneCodes.json");
  }

  verifyEmailSignup(token: string) {
    return this._httpClient.post(
      environment.apiUrl + 'auth/send-verification-email',
      {}, // empty body
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'skip-interceptor': 'true'
        }
      }
    );
  }
}

